/* import __COLOCATED_TEMPLATE__ from './infinite-list.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { debounce } from '@ember/runloop';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { guidFor } from '@ember/object/internals';
const SCROLL_DEBOUNCE_INTERVAL_MS = 300;
const BOTTOM_OFFSET = 100;
/**
 * An infinite-scrolling list component where rows are rendered by the consumer.
 *
 * @class InfiniteList
 * @extends {Component}
 * @param {String} [containerSelector] The selector of the containing element; this must
 * be scrollable. If it is not provided, it will bind to the window/document scrollable container
 * @param {Object} [items] Optional list of items to yield within a block.
 * @param {number} [offset=100] Bottom offset from the terminus to call lastItemBecameVisible.
 * @param {Function} lastItemBecameVisible Called when the last item becomes visible; this should
 * be used by consumers to load more rows.
 */
let InfiniteList = (_dec = computed(), _class = class InfiniteList extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "offset", BOTTOM_OFFSET);
    // -- Component arguments -- //
    _defineProperty(this, "containerSelector", '');
    _defineProperty(this, "lastItemBecameVisible", () => {
      // No-op default.
    });
  }
  get terminusUniqueIdentifier() {
    return `${guidFor(this)}-infinite-list--terminus`;
  }
  didInsertElement() {
    super.didInsertElement();
    if (this.containerSelector) {
      const element = document.querySelector(this.containerSelector);
      element?.addEventListener('scroll', this._onScrollDebounced);
    } else {
      window.addEventListener('scroll', this._onScrollDebounced);
      document.addEventListener('touchmove', this._onScrollDebounced);
    }
  }
  willDestroyElement() {
    super.willDestroyElement();
    if (this.containerSelector) {
      const element = document.querySelector(this.containerSelector);
      element?.removeEventListener('scroll', this._onScrollDebounced);
    } else {
      window.removeEventListener('scroll', this._onScrollDebounced);
      document.removeEventListener('touchmove', this._onScrollDebounced);
    }
  }
  _onScrollDebounced() {
    debounce(this, this._onScroll, SCROLL_DEBOUNCE_INTERVAL_MS);
  }
  _onScroll() {
    if (this._isTheEnd()) {
      this.lastItemBecameVisible();
    }
  }
  _getRect() {
    const terminus = document.querySelector(`.${this.terminusUniqueIdentifier}`);
    return terminus.getBoundingClientRect();
  }
  _isTheEnd() {
    if (this.isDestroyed || this.isDestroying) {
      return null;
    }
    const boundingRectangle = this._getRect();
    const terminusTopWithOffset = boundingRectangle.top - this.offset;
    if (this.containerSelector) {
      const elementBoundingRectangle = document.querySelector(this.containerSelector)?.getBoundingClientRect();
      return elementBoundingRectangle ? terminusTopWithOffset <= elementBoundingRectangle.top + elementBoundingRectangle.height : false;
    } else {
      // if the top of the terminus is above the bottom of the screen
      return terminusTopWithOffset <= (window.innerHeight || document.documentElement.clientHeight);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "terminusUniqueIdentifier", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "terminusUniqueIdentifier"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_onScrollDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_onScrollDebounced"), _class.prototype), _class);
export { InfiniteList as default };